import axiosClient from './axiosClient';

const accountApi = {
  // lay thong tin profile
  getProfile: () => {
    const url = '/user/profile';
    return axiosClient.get(url);
  },

  //cap nhat thong tin nguoi dung
  updateUser: (userId, params) => {
    const url = `/user/${userId}`;
    return axiosClient.put(url, params);
  }
};

export default accountApi;
